import { render, staticRenderFns } from "./TabChlorine.vue?vue&type=template&id=aafc46c4&"
import script from "./TabChlorine.vue?vue&type=script&lang=js&"
export * from "./TabChlorine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports